export const getClosestIndexFromChainage = (chainageValue, positionTimeData) => {
  let previousIndex = -1;
  let nextIndex = -1;
  let closestIndex = -1;
  const lastIndex = positionTimeData.length - 1;

  if (positionTimeData.length < 1) {
    // 'No Pos DATA, return -1'
    return closestIndex;
  }

  if (chainageValue <= positionTimeData[0].chainage) {
    return 0;
  } else if (chainageValue >= positionTimeData[lastIndex].chainage) {
    return lastIndex;
  }

  for (let i = 0; i < lastIndex; i++) {
    if (positionTimeData[i].chainage <= chainageValue
        && chainageValue <= positionTimeData[i + 1].chainage) {
      previousIndex = i;
      nextIndex = i + 1;
      break;
    }
  }
  if (previousIndex === -1) {
    // console.log('Not Expecting This ABORT');
  }

  if (chainageValue - positionTimeData[previousIndex].chainage
      < positionTimeData[nextIndex].chainage - chainageValue) {
    closestIndex = previousIndex;
  } else {
    closestIndex = nextIndex;
  }
  return closestIndex;
};

export const getClosestIndexFromTime = (timeInSec, positionTimeData) => {
  // console.log(timeInSec);
  let previousIndex = -1;
  let nextIndex = -1;
  let closestIndex = -1;
  if (positionTimeData.length === 0) {
    return closestIndex;
  }

  const lastIndex = positionTimeData.length - 1;

  if (timeInSec < positionTimeData[0].seconds) {
    return 0;
  } else if (timeInSec > positionTimeData[lastIndex].seconds) {
    return lastIndex;
  }
  for (let i = 0; i < positionTimeData.length - 1; i++) {
    // console.log(`timeInSec data : ${positionTimeData[i].seconds}
    // ${positionTimeData[i + 1].seconds}`);
    if (positionTimeData[i].seconds <= timeInSec
        && timeInSec <= positionTimeData[i + 1].seconds) {
      previousIndex = i;
      nextIndex = i + 1;
      break;
    }
  }

  if (timeInSec - positionTimeData[previousIndex].seconds
      < positionTimeData[nextIndex].seconds - timeInSec) {
    closestIndex = previousIndex;
  } else {
    closestIndex = nextIndex;
  }
  return closestIndex;
};

export const getClosestIndexFromLatLng = (latLng, positionTimeData, L) => {
  // console.log(coords.distanceTo(this.positionTimeData[0]));
  let closest = L.CRS.Earth.distance(latLng, positionTimeData[0]);
  let closestIndex = 0;

  for (let i = 1; i < positionTimeData.length; i++) {
    const tempDistance = L.CRS.Earth.distance(latLng, positionTimeData[i]);
    if (tempDistance < closest) {
      closest = tempDistance;
      closestIndex = i;
    }
  }
  return closestIndex;
};
